var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.title)+":")]),_c('span',{staticStyle:{"font-weight":"300","margin-left":"2%"}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }